"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = exports.ICON_PLACEMENT_END = exports.ICON_PLACEMENT_START = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorText = _interopRequireDefault(require("./ErrorText"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var IconExports = _interopRequireWildcard(require("../../foundation/Icons"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ICON_PLACEMENT_START = 'start';
exports.ICON_PLACEMENT_START = ICON_PLACEMENT_START;
var ICON_PLACEMENT_END = 'end';
exports.ICON_PLACEMENT_END = ICON_PLACEMENT_END;

var InputField = function InputField(props) {
  var _inputContainerClassN;

  var _onChange = props.onChange,
      label = props.label,
      classNames = props.classNames,
      size = props.size,
      name = props.name,
      id = props.id,
      value = props.value,
      defaultValue = props.defaultValue,
      type = props.type,
      disabled = props.disabled,
      isValid = props.isValid,
      placeholder = props.placeholder,
      icon = props.icon,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      iconPlacement = props.iconPlacement,
      errorText = props.errorText,
      onChangeValue = props.onChangeValue,
      hideError = props.hideError,
      tooltip = props.tooltip,
      tooltipIcon = props.tooltipIcon,
      useLight = props.useLight,
      NewProps = _objectWithoutProperties(props, ["onChange", "label", "classNames", "size", "name", "id", "value", "defaultValue", "type", "disabled", "isValid", "placeholder", "icon", "onFocus", "onBlur", "iconPlacement", "errorText", "onChangeValue", "hideError", "tooltip", "tooltipIcon", "useLight"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var labelClassNames = {
    'input-group__label-container__label': true,
    'input-group__label-container__label--disabled': disabled
  };
  var inputContainerClassNames = (_inputContainerClassN = {
    'input-group__input_container': true
  }, _defineProperty(_inputContainerClassN, "input-group__input_container--".concat(size), true), _defineProperty(_inputContainerClassN, 'input-group__input_container--valid', isValid === true), _defineProperty(_inputContainerClassN, 'input-group__input_container--invalid', isValid === false), _defineProperty(_inputContainerClassN, 'input-group__input_container--focused', isFocused && !NewProps.readOnly), _defineProperty(_inputContainerClassN, 'input-group__input_container--disabled', disabled), _defineProperty(_inputContainerClassN, 'input-group__input_container__light', useLight), _inputContainerClassN);
  var inputFieldClassNames = {
    'input-group__input_container__input': true,
    'input-group__input_container__input--disabled': disabled
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group"
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group__label-container"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(labelClassNames),
    htmlFor: id,
    id: "".concat(id, "__label")
  }, label), tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    tooltipBody: tooltip
  }, // @ts-ignore
  _react.default.createElement(IconExports[tooltipIcon]))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(inputContainerClassNames)
  }, icon && iconPlacement === ICON_PLACEMENT_START && /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group__input_container__icon"
  }, icon), /*#__PURE__*/_react.default.createElement("input", _extends({
    className: (0, _classnames.default)(inputFieldClassNames, classNames),
    name: name,
    id: id,
    value: value,
    defaultValue: defaultValue,
    type: type,
    "aria-labelledby": "".concat(id, "__label"),
    disabled: disabled,
    placeholder: placeholder,
    onChange: function onChange(e) {
      // if we have onChange prop, pass it the event
      if (_onChange) {
        _onChange(e);
      } // if we have onChangeValue, pass it the value


      if (onChangeValue) {
        onChangeValue(e.currentTarget.value);
      }
    },
    onFocus: function onFocus(e) {
      setIsFocused(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);

      if (_onBlur) {
        _onBlur(e);
      }
    }
  }, NewProps)), icon && iconPlacement === ICON_PLACEMENT_END && /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group__input_container__icon"
  }, icon)), !hideError && /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group__error_container"
  }, /*#__PURE__*/_react.default.createElement(_ErrorText.default, {
    classNames: "input-group__error_container__text"
  }, errorText)));
};

InputField.propTypes = {
  size: _propTypes.default.oneOf(['sm', 'lg']),
  type: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.any,
  iconPlacement: _propTypes.default.oneOf(['start', 'end']),
  hideError: _propTypes.default.bool,
  tooltipIcon: _propTypes.default.string,
  useLight: _propTypes.default.bool,
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.string]),
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  icon: _propTypes.default.node,
  isValid: _propTypes.default.bool,
  errorText: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onChangeValue: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  tooltip: _propTypes.default.string
};
var defaultProps = {
  classNames: '',
  size: 'lg',
  type: 'text',
  disabled: false,
  iconPlacement: ICON_PLACEMENT_START,
  hideError: false,
  tooltipIcon: 'IcoInfoCircle',
  useLight: false
};
exports.defaultProps = defaultProps;
InputField.defaultProps = defaultProps;
var _default = InputField;
exports.default = _default;